import { t } from "@travily/i18n";
import { ButtonGroup, ButtonGroupItem } from "@ui/components/ButtonGroup";
import { keysToArray } from "@ui/lib/selection";
import type { Selection } from "@ui/primitives/shared";
import type { TemperatureBand } from "@ui/utils/temperature-bands";

export type { TemperatureBand } from "@ui/utils/temperature-bands";

// i18n-tasks-use t('components.views.destinations.search.temperature_cool')
// i18n-tasks-use t('components.views.destinations.search.temperature_mild')
// i18n-tasks-use t('components.views.destinations.search.temperature_warm')
// i18n-tasks-use t('components.views.destinations.search.temperature_hot')
const OPTIONS: { id: TemperatureBand; labelKey: string }[] = [
  { id: "cool", labelKey: "components.views.destinations.search.temperature_cool" },
  { id: "mild", labelKey: "components.views.destinations.search.temperature_mild" },
  { id: "warm", labelKey: "components.views.destinations.search.temperature_warm" },
  { id: "hot", labelKey: "components.views.destinations.search.temperature_hot" },
];

export interface TemperatureFilterProps {
  onChange: (bands: TemperatureBand[]) => void;
  value: TemperatureBand[];
}

export function TemperatureFilter({ onChange, value }: TemperatureFilterProps) {
  const handleSelectionChange = (keys: Selection) => {
    onChange(keysToArray(keys, () => OPTIONS.map((o) => o.id)) as TemperatureBand[]);
  };

  return (
    <ButtonGroup
      aria-label={t("components.views.destinations.search.temperature_label")}
      onSelectionChange={handleSelectionChange}
      selectedKeys={new Set(value)}
      selectionMode="multiple"
      size="lg"
    >
      {OPTIONS.map((option) => (
        <ButtonGroupItem id={option.id} key={option.id}>
          {t(option.labelKey)}
        </ButtonGroupItem>
      ))}
    </ButtonGroup>
  );
}
